import AccountTrigger from "@/components/AccountTrigger"
import SearchTrigger from "@/components/SearchTrigger"
import { useIsMobile } from "@/hooks/use-is-mobile"
import { cn } from "@/lib/utils"
import CurrencySwitcher from "./currencySwitcher"
import MiniCartNewTrigger from "@/components/MiniCart/minicart-new-trigger"

export const HeaderRightTrigger = ({
  isSearchOpen,
  setIsSearchOpen,
  className,
  showHeader,
}: {
  isSearchOpen: boolean
  setIsSearchOpen: (isSearchOpen: boolean) => void
  className?: string
  showHeader: boolean
}) => {
  const { isMobile } = useIsMobile()

  return (
    <div
      className={cn(
        "col-start-4 mr-[12px] flex items-center justify-end gap-x-[25px] lg_mr-0",
        className
      )}
    >
      {!isMobile && (
        <>
          <SearchTrigger
            isOpen={isSearchOpen}
            onClick={() => {
              setIsSearchOpen(true)
            }}
            showHeader={showHeader}
          />
          <CurrencySwitcher />
        </>
      )}
      <AccountTrigger />
      <MiniCartNewTrigger />
    </div>
  )
}
